import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import './style.less'
const ProductDrop = ()=>{
    const productList = [
        {
            title:'CloudGPU',
            list:[
                {title:'NVIDIA RTX Pro 6000',path:'/productNew/9'},
                {title:'NVIDIA H200',path:'/productNew/10'},
                {title:'NVIDIA B200',path:'/productNew/11'},
                {title:'NVIDIA B300',path:'/productNew/12'},
                {title:'NVIDIA H100',path:'/productNew/2'},
                {title:'NVIDIA HGX A100',path:'/productNew/3'},
                {title:'NVIDIA A100 PCIe',path:'/productNew/4'},
                {title:'NVIDIA A40',path:'/productNew/5'},
                {title:'NVIDIA A16',path:'/productNew/6'},
            ]
        },
        {
            title:'Bare Metal',
            list:[
                {title:'Bare Metal',path:'productNew/8'},
            ]
        }
    ]
    return <div className='product_drop'>
                    <div className="flex left-flex">
                    {
                        productList.map(val=>{
                            return <div className="product_classfiy">
                            
                                        <div className="title">{val.title}</div>
                                        <div className='product_list'>
                                            {
                                                val.list.map(products=>{
                                                    return <div className="product_item">
                                                        <Link to={products.path}>
                                                            {products.title}
                                                        </Link>
                                                    </div>
                                                })
                                            }                       
                                        </div>
                                
                            </div>
                            
                        })
                    }
                    </div>
                   <div className="gray_cube">
                   Electron Gateway simplifies access to high-performance computing, offering cost-effective solutions tailored to your needs. Within minutes, you can deploy virtual machines equipped with fractional, single, or multiple NVIDIA GPUs. Reach out to us for customized contract terms and flexible payment plans.
                   </div>
    </div>
}
export default ProductDrop